import React from "react";

import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";

import ActionMenu from "components/ActionMenu";

import { useInvoiceActions } from "./useActions";
import { IbanInvoice } from "store/features/ibanInvoiceSlice";

import { ReactComponent as QrIcon } from "assets/images/actionMenu/qr-menu-icon.svg";
import { ReactComponent as CopyIcon } from "assets/images/actionMenu/copy-menu-icon.svg";
import { ReactComponent as ActionsIcon } from "assets/images/actionMenu/actions-menu-icon.svg";

import { styles } from "./styles";

interface ActionsProps {
  invoice: IbanInvoice | null;
}

const Actions: React.FC<ActionsProps> = (props) => {
  const { invoice } = props;

  const { ibanInvoiceUrl, actions, onCopy, onOpenQRCode } = useInvoiceActions({
    invoice,
  });

  return (
    <Stack sx={styles.actionsContainer}>
      {ibanInvoiceUrl && (
        <Box sx={[styles.urlWrapper, styles.hidden]}>
          <Typography noWrap>{ibanInvoiceUrl}</Typography>
        </Box>
      )}
      <IconButton sx={[styles.actionIcon, styles.hidden]} onClick={onCopy}>
        <CopyIcon />
      </IconButton>
      <IconButton
        sx={[styles.actionIcon, styles.hidden]}
        onClick={onOpenQRCode}
      >
        <QrIcon />
      </IconButton>
      <ActionMenu
        sx={styles.actionIcon}
        mainIcon={<ActionsIcon />}
        menuId="invoice-details-action-menu"
        actions={actions}
        row={invoice || undefined}
      />
    </Stack>
  );
};

export default Actions;
